module.exports = __webpack_public_path__ + "img/ico-like.88503089.svg";